/**
 * RDV en ligne (#429) — planning settings contract (Q1, Q-URL, Story 1.3 #506).
 *
 * The dispos (`workingHours`) and the entre-RDV time (`maxTimeBetweenEvents`)
 * already live on `CompanyOrganizationSetting` and are reused as-is (Q7).
 * Story 1.3 (#506) adds `maxTimeFromHome`, `maxTimeToHome` (the two missing
 * travel-time edges) and `maxTravelDistanceKm` (the distance guard-rail).
 *
 * Distance was originally a hidden constant (PRD "garde-fou caché"), but #506
 * promotes it to a stored, per-company configurable value: a hidden cap that
 * silently eliminates slots would penalize high-mileage trades (rural areas,
 * itinerant artisans). Default stays 150 km (RDV_DEFAULT_MAX_TRAVEL_DISTANCE_KM).
 *
 * `publicBookingSlug` is generated server-side and frozen at first activation
 * (Q-URL) — never set by the client, hence absent from the update payload.
 */
import { z } from "zod";
import { RDV_PROPOSAL_LIMIT } from "./constants.js";
export const UpdateRdvProposalLimitPayloadSchema = z.object({
    maxRdvProposals: z.number().int().min(1).max(RDV_PROPOSAL_LIMIT),
});
// One of the four allowed travel-time values, in minutes (Q1).
export const MaxTravelTimeMinutesSchema = z.union([
    z.literal(15),
    z.literal(30),
    z.literal(45),
    z.literal(60),
]);
// Distance guard-rail, in kilometers. A single configurable cap (#506) applied
// to every travel edge by the engine (Epic 2). Bounded to keep the value sane
// (anti-aberration) while staying generous enough for high-mileage trades.
export const MaxTravelDistanceKmSchema = z.number().int().min(1).max(2000);
/**
 * Payload for updating the RDV travel constraints (Q1, option A — the pro sets
 * all three time edges independently). `maxTimeBetweenEvents` maps to the
 * existing column; `maxTimeFromHome`/`maxTimeToHome`/`maxTravelDistanceKm` are
 * the new ones (#506). In V1 the UI applies a single time value to the three
 * edges and a single distance cap, but the contract stays per-edge for post-V1.
 */
export const UpdateRdvTravelSettingPayloadSchema = z.object({
    maxTimeFromHome: MaxTravelTimeMinutesSchema, // 🏠 → first appointment
    maxTimeBetweenEvents: MaxTravelTimeMinutesSchema, // appointment → appointment
    maxTimeToHome: MaxTravelTimeMinutesSchema, // last appointment → 🏠
    maxTravelDistanceKm: MaxTravelDistanceKmSchema, // hard distance cap (all edges)
});
//# sourceMappingURL=settings.types.js.map